export enum UpdateFrequency {
    DAYS = `d`,
    WEEKS = `w`,
    MONTHS = `M`,
    YEARS = `y`,
}
